import React from "react";
import { Route } from "react-router-dom";
import Activity from "../../../containers/modules/log/activity";

export default function ActivityRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="activity"
      index
      element={
        <Activity
        />
      }
    />
  );
}
